export default __webpack_public_path__ + "static/media/twf.329dbdc2.svg";